import React, { useState, useCallback } from "react";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

const DatePickerInput = ({
  date,
  setDate,
  title,
  icon,
  disabled,
  placeholder,
}: any) => {
  const [inputValue, setInputValue] = useState(date ? date : "");

  const handleDateChange = useCallback(
    (newDate: any) => {
      setDate(newDate);
      setInputValue(newDate ? newDate.format("YYYY/MM/DD") : "");
    },
    [setDate]
  );

  return (
    <div
      className={`datepicker_wrapper mb-4 mt-2 flex flex-col items-start ${
        disabled ? "disable-input" : ""
      }`}
    >
      <span className="text-sm text-gray-800 mb-2">{title}</span>
      <div className="datepicker_input_wrapper">
        {icon}
        <DatePicker
          value={date}
          onChange={handleDateChange}
          calendar={persian}
          locale={persian_fa}
          disabled={disabled}
          calendarPosition="top-left"
          monthYearSeparator="|"
          placeholder={placeholder}
        />
      </div>
    </div>
  );
};

export default DatePickerInput;
